import React from 'react'
import Aboutme from '../components/AboutMe'
import Skills from '../components/Skills'
import Quotes from '../components/Quotes'

const AboutPage = () => {
  return (
    <div>
  <Aboutme/>
  <Quotes/>
  <Skills/>
    </div>
  )
}

export default AboutPage
